'use client';
import React from 'react';

function NavigationLoading() {
  return (
    <div className="h-full space-x-8 ml-6">
      <ul className="flex h-full space-x-4">
        <li className="flex items-center animate-pulse">
          <div className="relative z-10 uppercase font-bold -mb-px flex items-center py-3 px-4 bg-primary-500 w-48" />
        </li>
      </ul>
    </div>
  );
}

export default NavigationLoading;
